import React, { memo, useCallback, useState } from "react";
import styles from "./styles.module.scss";
import Button from "app/components/Button/ButtonVariant";
import FileUpload from "app/components/FileUpload";
import { useTranslation } from "react-i18next";
import { PostMedia } from "app/components/paywalls";
import { MediaModel } from "app/models";

interface Props {
  titleContent?: React.ReactNode;
  icon?: React.ReactNode;
  hideUploadBtn?: boolean;
  canSelectMedia?: boolean;
  showLibrary?: boolean;
  hasPermission?: boolean;
  onSelectMedia?: (media?: MediaModel[]) => void;
  hasMultiSelect?: boolean;
  alreadySelectedData?: MediaModel[];
}

const CreateMedia = ({
  titleContent,
  icon,
  hideUploadBtn,
  canSelectMedia = true,
  showLibrary = true,
  hasPermission = false,
  onSelectMedia,
  hasMultiSelect,
  alreadySelectedData,
}: Props) => {
  const { t } = useTranslation();
  const onClose = () => {
    setModalIsOpen(false);
  };
  const [showPaywallModal, setShowPaywallModal] = useState(false);
  const [isModalOpen, setModalIsOpen] = useState(false);

  const onUpgrade = () => {
    onClose();
    setShowPaywallModal(true);
  };

  const closePaywall = useCallback(() => {
    setShowPaywallModal(false);
  }, []);

  const onModalOpen = () => {
    if (hasPermission) {
      setModalIsOpen(true);
    } else {
      return onUpgrade();
    }
  };

  return (
    <>
      <div className={styles.content_wrapper}>
        {!hideUploadBtn && (
          <Button
            title={titleContent ? titleContent : t("Upload")}
            icon={icon && icon}
            buttonType={hasPermission ? "secondary-outline" : "upgrade"}
            buttonStyles={styles.upload_btn}
            onClickFunc={onModalOpen}
            disabled={!canSelectMedia}
          />
        )}
      </div>
      {isModalOpen && (
        <FileUpload
          isOpen={isModalOpen}
          onClose={onClose}
          canSelectMedia={canSelectMedia}
          showLibrary={showLibrary}
          onSelectMedia={onSelectMedia}
          hasMultiSelect={hasMultiSelect}
          alreadySelected={alreadySelectedData}
        />
      )}
      <PostMedia show={showPaywallModal} onClose={closePaywall} />
    </>
  );
};

export default memo(CreateMedia);
